import { css } from "styled-components";
import { StyledHighlight } from "../../components/Highlight/Highlight";
export var ComboboxOptionMixin = function ComboboxOptionMixin() {
  return css(["", "{font-weight:bold;background-color:transparent;}"], StyledHighlight);
};